import {
  KEEP_DATA_FROM_QUOTE_MAPPING,
  keepDataFromQuoteMappings,
} from '@/features/Sparten/shared/keepDataFromQuoteMappings';

export const keepDataFromQuoteBaseProvidentDefinition = [
  ...keepDataFromQuoteMappings[KEEP_DATA_FROM_QUOTE_MAPPING.BIRTHDAY],
  ...keepDataFromQuoteMappings[KEEP_DATA_FROM_QUOTE_MAPPING.HEIGHT_AND_WEIGHT],
  ...keepDataFromQuoteMappings[KEEP_DATA_FROM_QUOTE_MAPPING.FAMILIENSTAND],
  ...keepDataFromQuoteMappings[KEEP_DATA_FROM_QUOTE_MAPPING.TARIFGRUPPE],
  ...keepDataFromQuoteMappings[KEEP_DATA_FROM_QUOTE_MAPPING.CHILDREN],
  ...keepDataFromQuoteMappings[
    KEEP_DATA_FROM_QUOTE_MAPPING.COMMERCIAL_WORK_PERCENTAGE
  ],
  ...keepDataFromQuoteMappings[KEEP_DATA_FROM_QUOTE_MAPPING.SMOKER],
  ...keepDataFromQuoteMappings[KEEP_DATA_FROM_QUOTE_MAPPING.BERUFSGRUPPE],
  ...keepDataFromQuoteMappings[
    KEEP_DATA_FROM_QUOTE_MAPPING.PERSONELL_RESPONSIBILITY
  ],
  ...keepDataFromQuoteMappings[KEEP_DATA_FROM_QUOTE_MAPPING.LEVEL_OF_EDUCATION],
];
